module.exports = __webpack_public_path__ + "4095eaa70e4d29dbfdb3561fa4d0640b.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/14-Betsolutions-Poker-Room.png
// module id = 1736
// module chunks = 2